import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-01-01 13:00:00`. */
  DateTime: any;
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: any;
};

export type Query = {
  __typename?: 'Query';
  dividend?: Maybe<Dividend>;
  dividends: Array<Dividend>;
  markets?: Maybe<Array<Market>>;
  market?: Maybe<Market>;
  order?: Maybe<Order>;
  portfolio?: Maybe<Portfolio>;
  listPortfolios: Array<Maybe<Portfolio>>;
  transactions: Array<Transaction>;
  transaction: Transaction;
  user?: Maybe<User>;
  me?: Maybe<User>;
};

export type QueryDividendArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryDividendsArgs = {
  orderBy?: Maybe<Array<QueryDividendsOrderByOrderByClause>>;
  portfolioId?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['String']>;
};

export type QueryMarketArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryOrderArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type QueryPortfolioArgs = {
  id: Scalars['ID'];
};

export type QueryTransactionsArgs = {
  status?: Maybe<TransactionStatus>;
  orderBy?: Maybe<Array<QueryTransactionsOrderByOrderByClause>>;
  portfolioId?: Maybe<Scalars['String']>;
  sellYear?: Maybe<Scalars['String']>;
};

export type QueryTransactionArgs = {
  id: Scalars['ID'];
};

export type QueryUserArgs = {
  id?: Maybe<Scalars['ID']>;
};

export type Dividend = {
  __typename?: 'Dividend';
  id: Scalars['ID'];
  transactionId: Scalars['ID'];
  transaction: Transaction;
  amount: Scalars['Float'];
  date: Scalars['Date'];
  commissions: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type Transaction = {
  __typename?: 'Transaction';
  id: Scalars['ID'];
  portfolio: Portfolio;
  stock: Stock;
  type: Scalars['String'];
  status: TransactionStatus;
  shares: Scalars['Float'];
  orders: Array<Order>;
  dividends: Array<Dividend>;
  buyPrice: Scalars['Float'];
  buyDate: Scalars['Date'];
  sellPrice?: Maybe<Scalars['Float']>;
  sellDate?: Maybe<Scalars['Date']>;
  commissions: Scalars['Float'];
  acquisitionValue: Scalars['Float'];
  transmissionValue?: Maybe<Scalars['Float']>;
  netReturns?: Maybe<Scalars['Float']>;
  grossReturns?: Maybe<Scalars['Float']>;
  returnYield?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type Portfolio = {
  __typename?: 'Portfolio';
  id: Scalars['ID'];
  user: User;
  name: Scalars['String'];
  currency: Scalars['String'];
  cost: Scalars['Float'];
  value: Scalars['Float'];
  balance: Scalars['Float'];
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID'];
  name: Scalars['String'];
  email: Scalars['String'];
  portfolios?: Maybe<Array<Maybe<Portfolio>>>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type UserPortfoliosArgs = {
  ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
};

export type Stock = {
  __typename?: 'Stock';
  id: Scalars['ID'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  value: Scalars['Float'];
  previousClose: Scalars['Float'];
  change: Scalars['Float'];
  changePercent: Scalars['Float'];
  market: Market;
  lastValueAt: Scalars['DateTime'];
};

export type Market = {
  __typename?: 'Market';
  id: Scalars['ID'];
  name: Scalars['String'];
  symbol: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  currency: Scalars['String'];
  stocks: Array<Stock>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export enum TransactionStatus {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

export type Order = {
  __typename?: 'Order';
  id: Scalars['ID'];
  transactionId: Scalars['ID'];
  transaction: Transaction;
  type: OrderType;
  shares: Scalars['Float'];
  price: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  date: Scalars['Date'];
  commissions: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export enum OrderType {
  Buy = 'BUY',
  Sell = 'SELL',
}

/** Order by clause for the `orderBy` argument on the query `dividends`. */
export type QueryDividendsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryDividendsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for the `orderBy` argument on field `dividends` on type `Query`. */
export enum QueryDividendsOrderByColumn {
  Date = 'DATE',
}

/** The available directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC',
}

/** Order by clause for the `orderBy` argument on the query `transactions`. */
export type QueryTransactionsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  column: QueryTransactionsOrderByColumn;
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Allowed column names for the `orderBy` argument on field `transactions` on type `Query`. */
export enum QueryTransactionsOrderByColumn {
  BuyDate = 'BUY_DATE',
}

export type Mutation = {
  __typename?: 'Mutation';
  login: AuthPayload;
  createDividend: Dividend;
  updateDividend?: Maybe<Dividend>;
  deleteDividend?: Maybe<Dividend>;
  createOrder: Order;
  updateOrder?: Maybe<Order>;
  deleteOrder?: Maybe<Order>;
  createPortfolio?: Maybe<Portfolio>;
  deletePortfolio?: Maybe<Portfolio>;
  createTransaction: Transaction;
  updateTransaction: Transaction;
  deleteTransaction?: Maybe<Transaction>;
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationCreateDividendArgs = {
  transactionId: Scalars['ID'];
  input: CreateDividendInput;
};

export type MutationUpdateDividendArgs = {
  id: Scalars['ID'];
  input: UpdateDividendInput;
};

export type MutationDeleteDividendArgs = {
  id: Scalars['ID'];
};

export type MutationCreateOrderArgs = {
  transactionId: Scalars['ID'];
  input: CreateOrderInput;
};

export type MutationUpdateOrderArgs = {
  id: Scalars['ID'];
  input: UpdateOrderInput;
};

export type MutationDeleteOrderArgs = {
  id: Scalars['ID'];
};

export type MutationCreatePortfolioArgs = {
  input: CreatePortfolioInput;
};

export type MutationDeletePortfolioArgs = {
  id: Scalars['ID'];
};

export type MutationCreateTransactionArgs = {
  input: CreateTransactionInput;
};

export type MutationUpdateTransactionArgs = {
  id: Scalars['ID'];
  input: UpdateTransactionInput;
};

export type MutationDeleteTransactionArgs = {
  id: Scalars['ID'];
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  accessToken: Scalars['String'];
  viewer: User;
};

export type CreateDividendInput = {
  date: Scalars['Date'];
  amount: Scalars['Float'];
  commissions?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
};

export type UpdateDividendInput = {
  date?: Maybe<Scalars['Date']>;
  amount?: Maybe<Scalars['Float']>;
  commissions?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
};

export type CreateOrderInput = {
  type: OrderType;
  date: Scalars['Date'];
  shares: Scalars['Float'];
  price: Scalars['Float'];
  commissions?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
};

export type UpdateOrderInput = {
  type?: Maybe<OrderType>;
  shares?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  date?: Maybe<Scalars['Date']>;
  commissions?: Maybe<Scalars['Float']>;
};

export type CreatePortfolioInput = {
  name?: Maybe<Scalars['String']>;
};

export type CreateTransactionInput = {
  stockId: Scalars['ID'];
  portfolioId: Scalars['ID'];
  type: Scalars['String'];
  status: TransactionStatus;
  orders?: Maybe<Array<CreateOrderInput>>;
};

export type UpdateTransactionInput = {
  portfolioId: Scalars['ID'];
};

export enum TransactionType {
  Long = 'LONG',
  Short = 'SHORT',
}

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Pagination information about the corresponding list of items. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Total count of available items in the page. */
  count: Scalars['Int'];
  /** Current pagination page. */
  currentPage: Scalars['Int'];
  /** Index of first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** If collection has more pages. */
  hasMorePages: Scalars['Boolean'];
  /** Index of last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Last page number of the collection. */
  lastPage: Scalars['Int'];
  /** Number of items per page in the collection. */
  perPage: Scalars['Int'];
  /** Total items available in the collection. */
  total: Scalars['Int'];
};

/** Pagination information about the corresponding list of items. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Total number of node in connection. */
  total?: Maybe<Scalars['Int']>;
  /** Count of nodes in current request. */
  count?: Maybe<Scalars['Int']>;
  /** Current page of request. */
  currentPage?: Maybe<Scalars['Int']>;
  /** Last page in connection. */
  lastPage?: Maybe<Scalars['Int']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT',
}

export type CreateDividendMutationVariables = Exact<{
  transactionId: Scalars['ID'];
  input: CreateDividendInput;
}>;

export type CreateDividendMutation = {
  __typename?: 'Mutation';
  createDividend: {
    __typename?: 'Dividend';
    id: string;
    transactionId: string;
    amount: number;
    date: any;
    exchangeRate: number;
    commissions: number;
  };
};

export type CreateOrderMutationVariables = Exact<{
  transactionId: Scalars['ID'];
  input: CreateOrderInput;
}>;

export type CreateOrderMutation = {
  __typename?: 'Mutation';
  createOrder: {
    __typename?: 'Order';
    id: string;
    transactionId: string;
    type: OrderType;
    date: any;
    shares: number;
    price: number;
    exchangeRate: number;
    commissions: number;
  };
};

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  login: {
    __typename?: 'AuthPayload';
    accessToken: string;
    viewer: { __typename?: 'User'; id: string; name: string; email: string };
  };
};

export type CreateTransactionMutationVariables = Exact<{
  input: CreateTransactionInput;
}>;

export type CreateTransactionMutation = {
  __typename?: 'Mutation';
  createTransaction: { __typename?: 'Transaction'; id: string };
};

export type ListMarketsQueryVariables = Exact<{ [key: string]: never }>;

export type ListMarketsQuery = {
  __typename?: 'Query';
  markets?: Maybe<
    Array<{
      __typename?: 'Market';
      id: string;
      name: string;
      country?: Maybe<string>;
      currency: string;
      stocks: Array<{
        __typename?: 'Stock';
        id: string;
        name: string;
        symbol: string;
        value: number;
        lastValueAt: any;
      }>;
    }>
  >;
};

export type ListPortfoliosQueryVariables = Exact<{ [key: string]: never }>;

export type ListPortfoliosQuery = {
  __typename?: 'Query';
  me?: Maybe<{
    __typename?: 'User';
    portfolios?: Maybe<
      Array<Maybe<{ __typename?: 'Portfolio'; id: string; name: string; cost: number; value: number; balance: number }>>
    >;
  }>;
};

export type GetPortfolioQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetPortfolioQuery = {
  __typename?: 'Query';
  portfolio?: Maybe<{
    __typename?: 'Portfolio';
    id: string;
    name: string;
    cost: number;
    transactions?: Maybe<
      Array<
        Maybe<{
          __typename?: 'Transaction';
          id: string;
          type: string;
          status: TransactionStatus;
          shares: number;
          buyPrice: number;
          buyDate: any;
          sellPrice?: Maybe<number>;
          sellDate?: Maybe<any>;
          commissions: number;
          netReturns?: Maybe<number>;
          grossReturns?: Maybe<number>;
          returnYield?: Maybe<number>;
          acquisitionValue: number;
          transmissionValue?: Maybe<number>;
          createdAt: any;
          updatedAt: any;
          stock: {
            __typename?: 'Stock';
            id: string;
            name: string;
            symbol: string;
            change: number;
            changePercent: number;
            previousClose: number;
            value: number;
            lastValueAt: any;
            market: { __typename?: 'Market'; id: string; name: string; country?: Maybe<string>; currency: string };
          };
          orders: Array<{
            __typename?: 'Order';
            id: string;
            type: OrderType;
            date: any;
            shares: number;
            price: number;
            commissions: number;
          }>;
        }>
      >
    >;
  }>;
};

export type ListPortfoliosTransactionsQueryVariables = Exact<{ [key: string]: never }>;

export type ListPortfoliosTransactionsQuery = {
  __typename?: 'Query';
  me?: Maybe<{
    __typename?: 'User';
    portfolios?: Maybe<
      Array<
        Maybe<{
          __typename?: 'Portfolio';
          id: string;
          name: string;
          cost: number;
          value: number;
          balance: number;
          transactions?: Maybe<
            Array<
              Maybe<{
                __typename?: 'Transaction';
                id: string;
                shares: number;
                sellDate?: Maybe<any>;
                acquisitionValue: number;
                transmissionValue?: Maybe<number>;
                stock: {
                  __typename?: 'Stock';
                  id: string;
                  value: number;
                  lastValueAt: any;
                  market: { __typename?: 'Market'; id: string; currency: string };
                };
              }>
            >
          >;
        }>
      >
    >;
  }>;
};

export type TransactionsBySellYearQueryVariables = Exact<{
  portfolioId: Scalars['String'];
  sellYear: Scalars['String'];
}>;

export type TransactionsBySellYearQuery = {
  __typename?: 'Query';
  transactions: Array<{
    __typename?: 'Transaction';
    id: string;
    type: string;
    status: TransactionStatus;
    shares: number;
    buyPrice: number;
    buyDate: any;
    sellPrice?: Maybe<number>;
    sellDate?: Maybe<any>;
    commissions: number;
    acquisitionValue: number;
    transmissionValue?: Maybe<number>;
    returnYield?: Maybe<number>;
    grossReturns?: Maybe<number>;
    netReturns?: Maybe<number>;
    createdAt: any;
    updatedAt: any;
    portfolio: { __typename?: 'Portfolio'; id: string; name: string };
    stock: {
      __typename?: 'Stock';
      id: string;
      name: string;
      symbol: string;
      value: number;
      market: { __typename?: 'Market'; id: string; name: string; country?: Maybe<string>; currency: string };
    };
    orders: Array<{
      __typename?: 'Order';
      id: string;
      type: OrderType;
      date: any;
      shares: number;
      price: number;
      commissions: number;
    }>;
    dividends: Array<{
      __typename?: 'Dividend';
      id: string;
      date: any;
      amount: number;
      exchangeRate: number;
      commissions: number;
    }>;
  }>;
};

export type ListTransactionsQueryVariables = Exact<{
  status?: Maybe<TransactionStatus>;
  orderBy?: Maybe<Array<QueryTransactionsOrderByOrderByClause> | QueryTransactionsOrderByOrderByClause>;
}>;

export type ListTransactionsQuery = {
  __typename?: 'Query';
  transactions: Array<{
    __typename?: 'Transaction';
    id: string;
    type: string;
    status: TransactionStatus;
    shares: number;
    buyPrice: number;
    buyDate: any;
    sellPrice?: Maybe<number>;
    sellDate?: Maybe<any>;
    commissions: number;
    netReturns?: Maybe<number>;
    grossReturns?: Maybe<number>;
    returnYield?: Maybe<number>;
    acquisitionValue: number;
    transmissionValue?: Maybe<number>;
    createdAt: any;
    updatedAt: any;
    portfolio: { __typename?: 'Portfolio'; id: string; name: string; currency: string; cost: number };
    stock: {
      __typename?: 'Stock';
      id: string;
      name: string;
      symbol: string;
      change: number;
      changePercent: number;
      previousClose: number;
      value: number;
      lastValueAt: any;
      market: {
        __typename?: 'Market';
        id: string;
        name: string;
        symbol: string;
        country?: Maybe<string>;
        currency: string;
      };
    };
    orders: Array<{
      __typename?: 'Order';
      id: string;
      type: OrderType;
      date: any;
      shares: number;
      price: number;
      commissions: number;
    }>;
  }>;
};

export type DeleteOrderMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteOrderMutation = {
  __typename?: 'Mutation';
  deleteOrder?: Maybe<{ __typename?: 'Order'; id: string }>;
};

export type UpdateOrderMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateOrderInput;
}>;

export type UpdateOrderMutation = {
  __typename?: 'Mutation';
  updateOrder?: Maybe<{
    __typename?: 'Order';
    id: string;
    type: OrderType;
    date: any;
    shares: number;
    price: number;
    exchangeRate: number;
    commissions: number;
  }>;
};

export type DeleteTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DeleteTransactionMutation = {
  __typename?: 'Mutation';
  deleteTransaction?: Maybe<{ __typename?: 'Transaction'; id: string }>;
};

export type GetTransactionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GetTransactionQuery = {
  __typename?: 'Query';
  transaction: {
    __typename?: 'Transaction';
    id: string;
    type: string;
    status: TransactionStatus;
    shares: number;
    buyPrice: number;
    buyDate: any;
    sellPrice?: Maybe<number>;
    sellDate?: Maybe<any>;
    commissions: number;
    netReturns?: Maybe<number>;
    grossReturns?: Maybe<number>;
    returnYield?: Maybe<number>;
    acquisitionValue: number;
    createdAt: any;
    updatedAt: any;
    portfolio: { __typename?: 'Portfolio'; id: string; name: string };
    stock: {
      __typename?: 'Stock';
      id: string;
      name: string;
      symbol: string;
      change: number;
      changePercent: number;
      previousClose: number;
      value: number;
      lastValueAt: any;
      market: {
        __typename?: 'Market';
        id: string;
        name: string;
        country?: Maybe<string>;
        currency: string;
        symbol: string;
      };
    };
    orders: Array<{
      __typename?: 'Order';
      id: string;
      transactionId: string;
      type: OrderType;
      date: any;
      shares: number;
      price: number;
      exchangeRate: number;
      commissions: number;
    }>;
    dividends: Array<{
      __typename?: 'Dividend';
      id: string;
      date: any;
      amount: number;
      exchangeRate: number;
      commissions: number;
      transaction: {
        __typename?: 'Transaction';
        id: string;
        stock: { __typename?: 'Stock'; id: string; market: { __typename?: 'Market'; id: string; currency: string } };
      };
    }>;
  };
};

export type UpdateTransactionMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateTransactionInput;
}>;

export type UpdateTransactionMutation = {
  __typename?: 'Mutation';
  updateTransaction: {
    __typename?: 'Transaction';
    id: string;
    type: string;
    status: TransactionStatus;
    shares: number;
    buyPrice: number;
    buyDate: any;
    sellPrice?: Maybe<number>;
    sellDate?: Maybe<any>;
    commissions: number;
    netReturns?: Maybe<number>;
    grossReturns?: Maybe<number>;
    returnYield?: Maybe<number>;
    createdAt: any;
    updatedAt: any;
    portfolio: { __typename?: 'Portfolio'; id: string; name: string };
    stock: {
      __typename?: 'Stock';
      id: string;
      name: string;
      symbol: string;
      change: number;
      changePercent: number;
      previousClose: number;
      value: number;
      lastValueAt: any;
      market: {
        __typename?: 'Market';
        id: string;
        name: string;
        country?: Maybe<string>;
        currency: string;
        symbol: string;
      };
    };
    orders: Array<{
      __typename?: 'Order';
      id: string;
      transactionId: string;
      type: OrderType;
      date: any;
      shares: number;
      price: number;
      exchangeRate: number;
      commissions: number;
    }>;
  };
};

export const CreateDividendDocument = gql`
  mutation createDividend($transactionId: ID!, $input: CreateDividendInput!) {
    createDividend(transactionId: $transactionId, input: $input) {
      id
      transactionId
      amount
      date
      exchangeRate
      commissions
    }
  }
`;
export type CreateDividendMutationFn = Apollo.MutationFunction<CreateDividendMutation, CreateDividendMutationVariables>;

/**
 * __useCreateDividendMutation__
 *
 * To run a mutation, you first call `useCreateDividendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDividendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDividendMutation, { data, loading, error }] = useCreateDividendMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDividendMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateDividendMutation, CreateDividendMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateDividendMutation, CreateDividendMutationVariables>(CreateDividendDocument, options);
}
export type CreateDividendMutationHookResult = ReturnType<typeof useCreateDividendMutation>;
export type CreateDividendMutationResult = Apollo.MutationResult<CreateDividendMutation>;
export type CreateDividendMutationOptions = Apollo.BaseMutationOptions<
  CreateDividendMutation,
  CreateDividendMutationVariables
>;
export const CreateOrderDocument = gql`
  mutation createOrder($transactionId: ID!, $input: CreateOrderInput!) {
    createOrder(transactionId: $transactionId, input: $input) {
      id
      transactionId
      type
      date
      shares
      price
      exchangeRate
      commissions
    }
  }
`;
export type CreateOrderMutationFn = Apollo.MutationFunction<CreateOrderMutation, CreateOrderMutationVariables>;

/**
 * __useCreateOrderMutation__
 *
 * To run a mutation, you first call `useCreateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrderMutation, { data, loading, error }] = useCreateOrderMutation({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateOrderMutation, CreateOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrderMutation, CreateOrderMutationVariables>(CreateOrderDocument, options);
}
export type CreateOrderMutationHookResult = ReturnType<typeof useCreateOrderMutation>;
export type CreateOrderMutationResult = Apollo.MutationResult<CreateOrderMutation>;
export type CreateOrderMutationOptions = Apollo.BaseMutationOptions<CreateOrderMutation, CreateOrderMutationVariables>;
export const LoginDocument = gql`
  mutation login($input: LoginInput!) {
    login(input: $input) {
      accessToken
      viewer {
        id
        name
        email
      }
    }
  }
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const CreateTransactionDocument = gql`
  mutation createTransaction($input: CreateTransactionInput!) {
    createTransaction(input: $input) {
      id
    }
  }
`;
export type CreateTransactionMutationFn = Apollo.MutationFunction<
  CreateTransactionMutation,
  CreateTransactionMutationVariables
>;

/**
 * __useCreateTransactionMutation__
 *
 * To run a mutation, you first call `useCreateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionMutation, { data, loading, error }] = useCreateTransactionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateTransactionMutation, CreateTransactionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTransactionMutation, CreateTransactionMutationVariables>(
    CreateTransactionDocument,
    options
  );
}
export type CreateTransactionMutationHookResult = ReturnType<typeof useCreateTransactionMutation>;
export type CreateTransactionMutationResult = Apollo.MutationResult<CreateTransactionMutation>;
export type CreateTransactionMutationOptions = Apollo.BaseMutationOptions<
  CreateTransactionMutation,
  CreateTransactionMutationVariables
>;
export const ListMarketsDocument = gql`
  query listMarkets {
    markets {
      id
      name
      country
      currency
      stocks {
        id
        name
        symbol
        value
        lastValueAt
      }
    }
  }
`;

/**
 * __useListMarketsQuery__
 *
 * To run a query within a React component, call `useListMarketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListMarketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListMarketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListMarketsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListMarketsQuery, ListMarketsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListMarketsQuery, ListMarketsQueryVariables>(ListMarketsDocument, options);
}
export function useListMarketsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListMarketsQuery, ListMarketsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListMarketsQuery, ListMarketsQueryVariables>(ListMarketsDocument, options);
}
export type ListMarketsQueryHookResult = ReturnType<typeof useListMarketsQuery>;
export type ListMarketsLazyQueryHookResult = ReturnType<typeof useListMarketsLazyQuery>;
export type ListMarketsQueryResult = Apollo.QueryResult<ListMarketsQuery, ListMarketsQueryVariables>;
export const ListPortfoliosDocument = gql`
  query listPortfolios {
    me {
      portfolios {
        id
        name
        cost
        value
        balance
      }
    }
  }
`;

/**
 * __useListPortfoliosQuery__
 *
 * To run a query within a React component, call `useListPortfoliosQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortfoliosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPortfoliosQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPortfoliosQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPortfoliosQuery, ListPortfoliosQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPortfoliosQuery, ListPortfoliosQueryVariables>(ListPortfoliosDocument, options);
}
export function useListPortfoliosLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPortfoliosQuery, ListPortfoliosQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPortfoliosQuery, ListPortfoliosQueryVariables>(ListPortfoliosDocument, options);
}
export type ListPortfoliosQueryHookResult = ReturnType<typeof useListPortfoliosQuery>;
export type ListPortfoliosLazyQueryHookResult = ReturnType<typeof useListPortfoliosLazyQuery>;
export type ListPortfoliosQueryResult = Apollo.QueryResult<ListPortfoliosQuery, ListPortfoliosQueryVariables>;
export const GetPortfolioDocument = gql`
  query getPortfolio($id: ID!) {
    portfolio(id: $id) {
      id
      name
      cost
      transactions {
        id
        stock {
          id
          name
          symbol
          change
          changePercent
          previousClose
          value
          lastValueAt
          market {
            id
            name
            country
            currency
          }
        }
        orders {
          id
          type
          date
          shares
          price
          commissions
        }
        type
        status
        shares
        buyPrice
        buyDate
        sellPrice
        sellDate
        commissions
        netReturns
        grossReturns
        returnYield
        acquisitionValue
        transmissionValue
        createdAt
        updatedAt
      }
    }
  }
`;

/**
 * __useGetPortfolioQuery__
 *
 * To run a query within a React component, call `useGetPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPortfolioQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPortfolioQuery(
  baseOptions: Apollo.QueryHookOptions<GetPortfolioQuery, GetPortfolioQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPortfolioQuery, GetPortfolioQueryVariables>(GetPortfolioDocument, options);
}
export function useGetPortfolioLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPortfolioQuery, GetPortfolioQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPortfolioQuery, GetPortfolioQueryVariables>(GetPortfolioDocument, options);
}
export type GetPortfolioQueryHookResult = ReturnType<typeof useGetPortfolioQuery>;
export type GetPortfolioLazyQueryHookResult = ReturnType<typeof useGetPortfolioLazyQuery>;
export type GetPortfolioQueryResult = Apollo.QueryResult<GetPortfolioQuery, GetPortfolioQueryVariables>;
export const ListPortfoliosTransactionsDocument = gql`
  query listPortfoliosTransactions {
    me {
      portfolios {
        id
        name
        cost
        value
        balance
        transactions {
          id
          shares
          sellDate
          acquisitionValue
          transmissionValue
          stock {
            id
            value
            lastValueAt
            market {
              id
              currency
            }
          }
        }
      }
    }
  }
`;

/**
 * __useListPortfoliosTransactionsQuery__
 *
 * To run a query within a React component, call `useListPortfoliosTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListPortfoliosTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListPortfoliosTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListPortfoliosTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListPortfoliosTransactionsQuery, ListPortfoliosTransactionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListPortfoliosTransactionsQuery, ListPortfoliosTransactionsQueryVariables>(
    ListPortfoliosTransactionsDocument,
    options
  );
}
export function useListPortfoliosTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListPortfoliosTransactionsQuery, ListPortfoliosTransactionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListPortfoliosTransactionsQuery, ListPortfoliosTransactionsQueryVariables>(
    ListPortfoliosTransactionsDocument,
    options
  );
}
export type ListPortfoliosTransactionsQueryHookResult = ReturnType<typeof useListPortfoliosTransactionsQuery>;
export type ListPortfoliosTransactionsLazyQueryHookResult = ReturnType<typeof useListPortfoliosTransactionsLazyQuery>;
export type ListPortfoliosTransactionsQueryResult = Apollo.QueryResult<
  ListPortfoliosTransactionsQuery,
  ListPortfoliosTransactionsQueryVariables
>;
export const TransactionsBySellYearDocument = gql`
  query transactionsBySellYear($portfolioId: String!, $sellYear: String!) {
    transactions(portfolioId: $portfolioId, sellYear: $sellYear) {
      id
      type
      status
      shares
      buyPrice
      buyDate
      sellPrice
      sellDate
      commissions
      acquisitionValue
      transmissionValue
      returnYield
      grossReturns
      netReturns
      createdAt
      updatedAt
      portfolio {
        id
        name
      }
      stock {
        id
        name
        symbol
        value
        market {
          id
          name
          country
          currency
        }
      }
      orders {
        id
        type
        date
        shares
        price
        commissions
      }
      dividends {
        id
        date
        amount
        exchangeRate
        commissions
      }
    }
  }
`;

/**
 * __useTransactionsBySellYearQuery__
 *
 * To run a query within a React component, call `useTransactionsBySellYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsBySellYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsBySellYearQuery({
 *   variables: {
 *      portfolioId: // value for 'portfolioId'
 *      sellYear: // value for 'sellYear'
 *   },
 * });
 */
export function useTransactionsBySellYearQuery(
  baseOptions: Apollo.QueryHookOptions<TransactionsBySellYearQuery, TransactionsBySellYearQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TransactionsBySellYearQuery, TransactionsBySellYearQueryVariables>(
    TransactionsBySellYearDocument,
    options
  );
}
export function useTransactionsBySellYearLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<TransactionsBySellYearQuery, TransactionsBySellYearQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TransactionsBySellYearQuery, TransactionsBySellYearQueryVariables>(
    TransactionsBySellYearDocument,
    options
  );
}
export type TransactionsBySellYearQueryHookResult = ReturnType<typeof useTransactionsBySellYearQuery>;
export type TransactionsBySellYearLazyQueryHookResult = ReturnType<typeof useTransactionsBySellYearLazyQuery>;
export type TransactionsBySellYearQueryResult = Apollo.QueryResult<
  TransactionsBySellYearQuery,
  TransactionsBySellYearQueryVariables
>;
export const ListTransactionsDocument = gql`
  query listTransactions($status: TransactionStatus, $orderBy: [QueryTransactionsOrderByOrderByClause!]) {
    transactions(status: $status, orderBy: $orderBy) {
      id
      portfolio {
        id
        name
        currency
        cost
      }
      stock {
        id
        name
        symbol
        change
        changePercent
        previousClose
        value
        lastValueAt
        market {
          id
          name
          symbol
          country
          currency
        }
      }
      orders {
        id
        type
        date
        shares
        price
        commissions
      }
      type
      status
      shares
      buyPrice
      buyDate
      sellPrice
      sellDate
      commissions
      netReturns
      grossReturns
      returnYield
      acquisitionValue
      transmissionValue
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useListTransactionsQuery__
 *
 * To run a query within a React component, call `useListTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTransactionsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListTransactionsQuery(
  baseOptions?: Apollo.QueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
}
export function useListTransactionsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListTransactionsQuery, ListTransactionsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListTransactionsQuery, ListTransactionsQueryVariables>(ListTransactionsDocument, options);
}
export type ListTransactionsQueryHookResult = ReturnType<typeof useListTransactionsQuery>;
export type ListTransactionsLazyQueryHookResult = ReturnType<typeof useListTransactionsLazyQuery>;
export type ListTransactionsQueryResult = Apollo.QueryResult<ListTransactionsQuery, ListTransactionsQueryVariables>;
export const DeleteOrderDocument = gql`
  mutation deleteOrder($id: ID!) {
    deleteOrder(id: $id) {
      id
    }
  }
`;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
}
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const UpdateOrderDocument = gql`
  mutation updateOrder($id: ID!, $input: UpdateOrderInput!) {
    updateOrder(id: $id, input: $input) {
      id
      type
      date
      shares
      price
      exchangeRate
      commissions
    }
  }
`;
export type UpdateOrderMutationFn = Apollo.MutationFunction<UpdateOrderMutation, UpdateOrderMutationVariables>;

/**
 * __useUpdateOrderMutation__
 *
 * To run a mutation, you first call `useUpdateOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderMutation, { data, loading, error }] = useUpdateOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateOrderMutation, UpdateOrderMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateOrderMutation, UpdateOrderMutationVariables>(UpdateOrderDocument, options);
}
export type UpdateOrderMutationHookResult = ReturnType<typeof useUpdateOrderMutation>;
export type UpdateOrderMutationResult = Apollo.MutationResult<UpdateOrderMutation>;
export type UpdateOrderMutationOptions = Apollo.BaseMutationOptions<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const DeleteTransactionDocument = gql`
  mutation deleteTransaction($id: ID!) {
    deleteTransaction(id: $id) {
      id
    }
  }
`;
export type DeleteTransactionMutationFn = Apollo.MutationFunction<
  DeleteTransactionMutation,
  DeleteTransactionMutationVariables
>;

/**
 * __useDeleteTransactionMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionMutation, { data, loading, error }] = useDeleteTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<DeleteTransactionMutation, DeleteTransactionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTransactionMutation, DeleteTransactionMutationVariables>(
    DeleteTransactionDocument,
    options
  );
}
export type DeleteTransactionMutationHookResult = ReturnType<typeof useDeleteTransactionMutation>;
export type DeleteTransactionMutationResult = Apollo.MutationResult<DeleteTransactionMutation>;
export type DeleteTransactionMutationOptions = Apollo.BaseMutationOptions<
  DeleteTransactionMutation,
  DeleteTransactionMutationVariables
>;
export const GetTransactionDocument = gql`
  query getTransaction($id: ID!) {
    transaction(id: $id) {
      id
      portfolio {
        id
        name
      }
      stock {
        id
        name
        symbol
        change
        changePercent
        previousClose
        value
        lastValueAt
        market {
          id
          name
          country
          currency
          symbol
        }
      }
      orders {
        id
        transactionId
        type
        date
        shares
        price
        exchangeRate
        commissions
      }
      dividends {
        id
        date
        amount
        exchangeRate
        commissions
        transaction {
          id
          stock {
            id
            market {
              id
              currency
            }
          }
        }
      }
      type
      status
      shares
      buyPrice
      buyDate
      sellPrice
      sellDate
      commissions
      netReturns
      grossReturns
      returnYield
      acquisitionValue
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetTransactionQuery__
 *
 * To run a query within a React component, call `useGetTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTransactionQuery(
  baseOptions: Apollo.QueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
}
export function useGetTransactionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionQuery, GetTransactionQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTransactionQuery, GetTransactionQueryVariables>(GetTransactionDocument, options);
}
export type GetTransactionQueryHookResult = ReturnType<typeof useGetTransactionQuery>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<GetTransactionQuery, GetTransactionQueryVariables>;
export const UpdateTransactionDocument = gql`
  mutation updateTransaction($id: ID!, $input: UpdateTransactionInput!) {
    updateTransaction(id: $id, input: $input) {
      id
      portfolio {
        id
        name
      }
      stock {
        id
        name
        symbol
        change
        changePercent
        previousClose
        value
        lastValueAt
        market {
          id
          name
          country
          currency
          symbol
        }
      }
      orders {
        id
        transactionId
        type
        date
        shares
        price
        exchangeRate
        commissions
      }
      type
      status
      shares
      buyPrice
      buyDate
      sellPrice
      sellDate
      commissions
      netReturns
      grossReturns
      returnYield
      createdAt
      updatedAt
    }
  }
`;
export type UpdateTransactionMutationFn = Apollo.MutationFunction<
  UpdateTransactionMutation,
  UpdateTransactionMutationVariables
>;

/**
 * __useUpdateTransactionMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionMutation, { data, loading, error }] = useUpdateTransactionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransactionMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateTransactionMutation, UpdateTransactionMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateTransactionMutation, UpdateTransactionMutationVariables>(
    UpdateTransactionDocument,
    options
  );
}
export type UpdateTransactionMutationHookResult = ReturnType<typeof useUpdateTransactionMutation>;
export type UpdateTransactionMutationResult = Apollo.MutationResult<UpdateTransactionMutation>;
export type UpdateTransactionMutationOptions = Apollo.BaseMutationOptions<
  UpdateTransactionMutation,
  UpdateTransactionMutationVariables
>;
